var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLikePost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8013 8.1545C19.4002 7.70385 18.5845 7.52809 17.1695 7.57766L11.8923 7.76694C12.3925 6.91971 12.8161 6.03192 13.1586 5.11259C13.5102 4.07608 13.5282 3.2604 13.2217 2.61596C12.8161 1.76874 11.8517 1.24147 10.2745 1.00262C10.1573 0.984598 10.0446 1.06121 10.0176 1.17838C9.74268 2.38613 7.77333 6.94675 6.33123 8.69078L1.22533 8.80795C1.10365 8.80795 1.00451 8.9116 1 9.03328V18.123C1 18.2491 1.10365 18.3528 1.22983 18.3528H15.475C16.6106 18.3753 17.7012 17.8931 18.4493 17.0414C19.1929 16.1581 19.6255 15.0585 19.6886 13.9093L19.959 10.3717C19.9725 10.1824 19.9996 9.98866 20.0266 9.80389C20.1167 9.17748 20.1979 8.59163 19.8013 8.14999V8.1545ZM1.45967 9.2586L6.21407 9.15044V17.8976H1.45967V9.2586ZM19.576 9.74531C19.5489 9.93909 19.5219 10.1374 19.5038 10.3447L19.2335 13.8823C19.0802 15.8832 17.859 17.9021 15.475 17.9021H6.66923V9.03778C6.66923 9.03778 6.66923 9.01976 6.66923 9.01074C8.12934 7.2577 9.99055 2.96297 10.4097 1.49384C11.703 1.71916 12.4872 2.15179 12.8116 2.81876C13.3479 3.92737 12.5908 5.65337 11.2929 7.90213C11.2298 8.01029 11.2659 8.14999 11.3786 8.21309C11.4146 8.23562 11.4597 8.24463 11.5002 8.24463L17.1875 8.03733C18.4223 7.99226 19.1659 8.13197 19.4633 8.46094C19.7202 8.74486 19.6526 9.20903 19.576 9.74531Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.456969,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikePost);
export default __webpack_public_path__ + "static/media/LikePost.4715cb33170900e05febdd71d9a227d1.svg";
export { ForwardRef as ReactComponent };